import React,
{
  ReactElement, useEffect,
} from 'react';
import { useDispatch } from 'react-redux';
import { exchangeToken, refreshLegacyToken, refreshToken } from 'reducers/UserInfo';
import { useQueryParam } from 'use-query-params';
import { useHistory } from 'react-router-dom';
import LoadingOverlay from 'components/LoadingOverlay';
import { completeIconDomainHop } from 'lib/iconRedirectSession';

function IconRedirect(): ReactElement {
  const [jwt] = useQueryParam<string>('jwt');
  const [redirectTo] = useQueryParam<string>('redirectTo');
  const [token] = useQueryParam<string>('refresh_token');
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    let isMounted = true;
    const targetPath = redirectTo ?? '/';

    const redirectToLogin = (): void => {
      if (isMounted) {
        history.push(`/login?redirectTo=${targetPath}`);
      }
    };

    const redirectToTarget = async (): Promise<void> => {
      try {
        const ok = await completeIconDomainHop({
          jwt,
          refreshToken: token,
          saveJwt: (nextJwt) => {
            dispatch(refreshToken(nextJwt));
          },
          refreshLegacySession: async (refresh) => {
            await dispatch(refreshLegacyToken(refresh));
          },
          establishLegacyCookie: async () => {
            await dispatch(exchangeToken(() => undefined));
          },
        });

        if (!ok) {
          redirectToLogin();
          return;
        }

        if (isMounted) {
          history.push(targetPath);
        }
      } catch {
        redirectToLogin();
      }
    };

    redirectToTarget();

    return () => {
      isMounted = false;
    };
  }, [dispatch, history, jwt, redirectTo, token]);

  return (
    <LoadingOverlay isVisible loadingText="Redirecting to Icon..." />
  )
}

export default IconRedirect;
